<template>
    <div id="communication-menu">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item active">Riesgo crediticio</li>
            </ol>
        </nav>

        <div class="container-fluid">
            <div class="row">
                <vs-divider>HERRAMIENTAS</vs-divider>
                <div class="col-sm-12 col-md-6 col-lg-3">
                    <vx-card class="text-center feedback">
                        <vs-button @click="$router.push('/score-busqueda')" type="line" size="large">Búsqueda</vs-button>
                    </vx-card>
                </div>

                <div class="col-sm-12 col-md-6 col-lg-3">
                    <vx-card class="text-center investorsPrograms">
                        <vs-button @click="$router.push('/reporte-consultas-automaticas')" type="line" size="large">Reporte consultas <br>CDC</vs-button>
                    </vx-card>
                </div>
                <vs-divider>PROVEEDORES</vs-divider>
                <div class="col-sm-12 col-md-6 col-lg-3">
                    <vx-card class="text-center investorsPrograms">
                        <vs-button @click="$router.push('/verificacion-proveedores')" type="line" size="large">Verificación de <br>proveedores</vs-button>
                    </vx-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SecurityMenu from "../../../components/security-menu/security-menu.vue";

export default {
  components: {SecurityMenu}

}
</script>

<style scoped>
    .vx-card {
        cursor: pointer !important;
        margin-bottom: 1rem !important;
        min-height: 6.5rem !important;
    }

    .feedback button {
        padding: 14px !important;
        padding-left: 5px !important;
    }
    .investorsPrograms button {
        padding: 5.5px !important;
    }
</style>
